import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserModulePushOutput } from 'infrastructure/graphql/messaging/user/model/user-module-push.output';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface ResendUserModulePushInput {
	readonly pushOrgModuleId: string;
	readonly contactId: string;
	readonly userId: string;
}

export interface ResendUserModulePushParams {
	input: ResendUserModulePushInput;
}

@Injectable({ providedIn: 'root' })
export class ResendUserModulePushApiMutation extends ApiMutation<
	UserModulePushOutput[],
	ResendUserModulePushParams
> {
	client = 'messaging';
	document = gql`
		mutation ResendUserModulePush($input: ResendUserModulePushInput!) {
			resendUserModulePush(input: $input) {
				contactEmailAddress
				pushOrgModuleId
				contactLanguage
				contactName
				contactId
				emailId
				status
			}
		}
	`;
	method = 'resendUserModulePush';
}
